export default "__VITE_ASSET__DmCuwT_E__"